import React, { createContext, ReactNode, useCallback, useContext, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import ToastContainer from '../components/ToastContainer';

export interface ToastMessage {
  id: string;
  type?: 'success' | 'error' | 'info';
  title: string;
  description?: string;
}

interface ToastContextData {
  addToast(message: Omit<ToastMessage, 'id'>): void;
  removeToast(id: string): void;
  callToast(id: string): void;
}

const ToastContext = createContext<ToastContextData>({} as ToastContextData);

interface ToastProviderProps {
    children: ReactNode;
}

const ToastProvider: React.FC<ToastProviderProps> = ({ children}) => {
  const [messages, setMessages] = useState<ToastMessage[]>([]);

  const addToast = useCallback((message: Omit<ToastMessage, 'id'>) => {
    const id = uuidv4();

    const toast = {
      id,
      ...message,
    };

    setMessages(state => [...state, toast]);
  }, []);

  const callToast = useCallback((id: string) => {
    setMessages(state => state.filter(message => message.id === id));
  }, []);


  const removeToast = useCallback((id: string) => {
    setMessages(state => state.filter(message => message.id !== id));
  }, []);

  React.useEffect(() =>{

  },[addToast, callToast, messages])

  return (
    <ToastContext.Provider value={{ addToast, callToast, removeToast }}>
      {children}
      <ToastContainer messages={messages} />
    </ToastContext.Provider>
  );
};

function useToast(): ToastContextData {
  const context = useContext(ToastContext);

  if (!context) {
    throw new Error('useToast só pode ser usado com um ToastProvider');
  }

  return context;
}

export { ToastProvider, useToast };
